import { CrmEntityType } from '@prisma/client';

export const OLDEST_DUE_AGE_METRIC = 'crm_sync.oldest_due_age_seconds';
export const BACKLOG_SIZE_METRIC = 'crm_sync.backlog_size';
export const QUARANTINED_METRIC = 'crm_sync.quarantined';
export const WRITTEN_METRIC = 'crm_sync.written';
export const SKIPPED_UNCHANGED_METRIC = 'crm_sync.skipped_unchanged';
export const ERRORS_METRIC = 'crm_sync.errors';
export const RATE_LIMITED_METRIC = 'crm_sync.rate_limited';
export const UNMAPPED_METRIC = 'crm_sync.unmapped';
export const ROWS_READ_METRIC = 'crm_sync.rows_read';
export const DEFERRED_METRIC = 'crm_sync.deferred';
export const HUBSPOT_CALLS_METRIC = 'crm_sync.hubspot_calls';
/**
 * A create that found a pre-existing HubSpot object by its identifying property and updated it
 * instead. For COMPANY this is the adoption signal: a company HubSpot created itself for this user
 * that would otherwise have been duplicated. Its counterpart `NEW_CREATES_METRIC` counts creates
 * that really did create, so the two sum to the successful creates for the run.
 */
export const RESOLVED_CREATES_METRIC = 'crm_sync.resolved_creates';
/** A create that resolved to nothing pre-existing and made a real HubSpot create call. */
export const NEW_CREATES_METRIC = 'crm_sync.new_creates';
export const ENTITY_TYPE_TAG_KEY = 'entity_type';
export const STAGE_TAG_KEY = 'stage';

/** Lowercased tag values for `ENTITY_TYPE_TAG_KEY`, derived from `CrmEntityType` so it can't drift from the enum. */
export const ENTITY_TYPE_TAG_VALUES = Object.values(CrmEntityType).map(entityType =>
  entityType.toLowerCase(),
) as Lowercase<CrmEntityType>[];
